import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const SingleLineTextFieldInner = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    height: "32px",
    backgroundColor: "#ffffff",
    [theme.breakpoints.up("sm")]: {
      height: "34px",
      borderRadius: "8px",
    },
    borderRadius: "8px",
    "& fieldset": {
      borderColor: "#D9D9D9",
    },
    "&:hover fieldset": {
      borderColor: "#D9D9D9",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#D9D9D9 !important",
    },
    "&.Mui-focused": {
      outline: "none",
      boxShadow: "none",
    },
    "&.Mui-disabled": (ownerState: any) => ({
      backgroundColor: `${
        (ownerState as any)?.colors?.background?.disabled
      } !important`,
      "& fieldset": {
        borderColor: `${
          (ownerState as any)?.colors?.border?.medium
        } !important`,
      },
    }),
  },
  "& .MuiOutlinedInput-input": {
    padding: "8px 12px",
    fontSize: "12px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "12px",
      padding: "8px 12px",
    },
    "&::placeholder": (ownerState: any) => ({
      fontSize: "12px",
      opacity: 0.8,
      [theme.breakpoints.up("sm")]: {
        fontSize: "12px",
      },
      color: (ownerState as any)?.colors?.text?.placeholder,
    }),
    "&.Mui-disabled": (ownerState: any) => ({
      color: `${(ownerState as any)?.colors?.text?.primary} !important`,
      WebkitTextFillColor: `${
        (ownerState as any)?.colors?.text?.primary
      } !important`,
    }),
  },
  "@media (max-width: 600px)": {
    "& .MuiOutlinedInput-input": {
      fontSize: "12px",
      "&::placeholder": {
        fontSize: "12px",
      },
    },
  },
}));

export const SingleLineTextField =
  SingleLineTextFieldInner as unknown as typeof TextField;

const CustomTextAreaFieldInner = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#ffffff",
    [theme.breakpoints.up("sm")]: {
      borderRadius: "8px",
    },
    borderRadius: "8px",
    "& fieldset": {
      borderColor: "#D9D9D9",
    },
    "&:hover fieldset": {
      borderColor: "#D9D9D9",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#D9D9D9 !important",
    },
    "&.Mui-focused": {
      outline: "none",
      boxShadow: "none",
    },
    "&.Mui-disabled": (ownerState: any) => ({
      backgroundColor: `${
        (ownerState as any)?.colors?.background?.disabled
      } !important`,
      "& fieldset": {
        borderColor: `${
          (ownerState as any)?.colors?.border?.medium
        } !important`,
      },
    }),
  },
  "& .MuiOutlinedInput-input": {
    fontSize: "12px",
    "&::placeholder": (ownerState: any) => ({
      fontSize: "12px",
      opacity: 0.8,
      color: (ownerState as any)?.colors?.text?.placeholder,
    }),
    "&.Mui-disabled": (ownerState: any) => ({
      color: `${(ownerState as any)?.colors?.text?.primary} !important`,
      WebkitTextFillColor: `${
        (ownerState as any)?.colors?.text?.primary
      } !important`,
    }),
  },
}));

export const CustomTextAreaField =
  CustomTextAreaFieldInner as unknown as typeof TextField;
